var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRegistered(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3163_17448",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3163_17448)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100 182.773C98.3542 182.773 96.7785 182.522 95.2729 182.019C93.766 181.518 92.3292 180.764 90.9625 179.758L43.525 144.183C41.6556 142.815 40.184 141.058 39.1104 138.911C38.0368 136.763 37.5 134.504 37.5 132.131V35.8981C37.5 31.6884 38.9583 28.1252 41.875 25.2085C44.7917 22.2918 48.3549 20.8335 52.5646 20.8335H147.435C151.645 20.8335 155.208 22.2918 158.125 25.2085C161.042 28.1252 162.5 31.6884 162.5 35.8981V132.131C162.5 134.504 161.963 136.763 160.89 138.911C159.816 141.058 158.344 142.815 156.475 144.183L109.037 179.758C107.671 180.764 106.234 181.518 104.727 182.019C103.222 182.522 101.646 182.773 100 182.773ZM98.4771 169.711C98.9049 170.086 99.4125 170.273 100 170.273C100.587 170.273 101.095 170.086 101.523 169.711L148.958 134.136C149.279 133.868 149.533 133.56 149.719 133.213C149.906 132.865 150 132.479 150 132.052V35.8981C150 35.2564 149.733 34.6689 149.198 34.1356C148.665 33.6009 148.077 33.3335 147.435 33.3335H52.5646C51.9229 33.3335 51.3354 33.6009 50.8021 34.1356C50.2674 34.6689 50 35.2564 50 35.8981V132.052C50 132.479 50.0938 132.865 50.2813 133.213C50.4674 133.56 50.7208 133.868 51.0417 134.136L98.4771 169.711ZM91.25 104.296L77.9812 91.0252C76.741 89.7863 75.2903 89.1752 73.6292 89.1918C71.9681 89.2071 70.491 89.8182 69.1979 91.0252C67.9062 92.3182 67.2389 93.8036 67.1958 95.4814C67.1528 97.1578 67.7778 98.6425 69.0708 99.9356L85.9771 116.844C87.484 118.349 89.2417 119.102 91.25 119.102C93.2583 119.102 95.016 118.349 96.5229 116.844L131.058 82.3085C132.297 81.0682 132.908 79.6175 132.892 77.9564C132.876 76.2953 132.265 74.8182 131.058 73.5252C129.765 72.2335 128.28 71.5661 126.602 71.5231C124.926 71.48 123.441 72.105 122.148 73.3981L91.25 104.296Z",
    fill: "#169c50"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegistered);
export default __webpack_public_path__ + "static/media/Registered.512b68fe7369526faf8c422856e11b6b.svg";
export { ForwardRef as ReactComponent };